import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

declare global {
  interface Window {
    TRANSLATIONS: any;
  }
}

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    supportedLngs:
      process.env.NODE_ENV === "development"
        ? ["en"]
        : [
            "en",
            "es",
            "pl",
            "fr",
            "ro",
            "ru",
            "lt",
            "uk",
            "zh",
            "hi",
            "ko",
            "el",
            "ch",
            "haw",
            "ilo",
          ],
    nonExplicitSupportedLngs: true,
    keySeparator: false,
    nsSeparator: false,
    pluralSeparator: "/",
    contextSeparator: "\\",
    resources: window.TRANSLATIONS,

    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: { order: ["navigator"] },
  });

export default i18n;
